import React, { Component } from 'react';
import {
  ActivityIndicator,
  Alert,
  Dimensions,
  Image,
  PixelRatio,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  FontAwesomeIcon,
  KeyboardAwareScrollView,
  NavigationActions,
} from '../modules';

import { updateCredential, updateInfo } from '../actions/user';
import Utils from '../utils/Utils';
import UserUtils from '../utils/UserUtils';
import APIClient from '../utils/APIClient';

const windowWidth = Dimensions.get('window').width;
const logoRatio = 2208.0 / 3264;
const logoWidth = Math.min(windowWidth, 340);
const logoHeight = logoWidth * logoRatio;
const logoImageSize = logoWidth * 2 / 3;
const formWidth = Math.min(windowWidth - 40, 300);
;

class LoginScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {params} = navigation.state;
    return {
      header: null,
    };
  };

  constructor (props) {
    super(props);

    const {credential} = this.props;
    let {username, password} = credential ? credential : {};
    this.state = {
      username: username ? username : '',
      password: password ? password : '',
      submitting: false,
    };
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  _updateInputValue (name, value) {
    this.setState({
      [name]: value,
    });
  }

  _focusTextInput (name) {
    const textInput = this.refs[name];
    if (textInput) {
      textInput.focus();
    }
  }

  _login = async () => {
    const {submitting} = this.state;
    if (submitting) {
      return;
    }

    const {username, password} = this.state;
    let errorMessage, inputRefName;
    if (_.isEmpty(username)) {
      errorMessage = 'Vui lòng điền địa chỉ email';
      inputRefName = 'emailTextInput';
    } else if (_.isEmpty(password)) {
      errorMessage = 'Vui lòng điền mật khẩu';
      inputRefName = 'passwordTextInput';
    }

    if (errorMessage) {
      if (Platform.OS === 'web') {
        alert(errorMessage);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          errorMessage,
          [
            {text: 'OK', onPress: () => this._focusTextInput(inputRefName)},
          ],
        );
      }
      return;
    }

    this.setState({
      submitting: true,
    });

    const credential = {
      username: username,
      password: password,
    };
    APIClient.updateCredential(credential);
    const {response, error} = await APIClient.POST('/user/signIn');
    this._handleNetworkResponse(credential, response, error);
  };

  _handleNetworkResponse (credential, response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    this.setState({
      submitting: false,
    });

    if (response && response.response) {
      const {device, updateCredential, updateInfo} = this.props;
      UserUtils.updateFCMToken(credential, device.fcmToken);
      updateCredential(credential);
      updateInfo(response.response);
    } else {
      const message = Utils.parseErrorMessage(response, error,
        'Đăng nhập thất bại, vui lòng thử lại sau');
      if (Platform.OS === 'web') {
        alert(message);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          message,
        );
      }
    }
  }

  _register = () => {
    if (Platform.OS !== 'web') {
      this.props.navigation.navigate('Registration', {
        onSubmmit: this._handleRegistration,
      });
    }
  };

  _handleRegistration = (data) => {
    const {email} = data;
    this.setState({
      username: email,
    });
    if (Platform.OS !== 'web') {
      this.props.updateCredential({
        username: email,
      });
      this.props.navigation.dispatch(NavigationActions.back());
    }
  };

  _forgetPassword = () => {
    if (Platform.OS !== 'web') {
      this.props.navigation.navigate('Password', {});
    }
  };

  _close = () => {
    if (Platform.OS !== 'web') {
      const backAction = NavigationActions.back();
      this.props.navigation.dispatch(backAction);
    }
  };

  render () {
    const {username, password, submitting} = this.state;
    return (
      <View
        style={styles.container}>

        <KeyboardAwareScrollView
          automaticallyAdjustContentInsets={false}
          keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
          keyboardShouldPersistTaps='never'
          containerContentStyle={styles.contentContainer}
          style={styles.content}>
          <View
            style={styles.logo}>
            <Image
              source={require('../img/bg.png')}
              style={styles.logoBackground}/>
            <Image
              source={require('../img/logo.png')}
              style={styles.logoImage}/>
          </View>

          <View
            style={[
              styles.input, {
                marginTop: 40,
              }]}>
            <TextInput
              ref='emailTextInput'
              value={username}
              placeholder='Địa chỉ email'
              placeholderTextColor='#51585ebf'
              keyboardType='email-address'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              autoCapitalize='none'
              autoFocus
              returnKeyType='next'
              onChangeText={(text) => this._updateInputValue('username', text)}
              onSubmitEditing={() => this._focusTextInput('passwordTextInput')}
              style={styles.textInput}/>
          </View>

          <View
            style={styles.input}>
            <TextInput
              ref='passwordTextInput'
              value={password}
              placeholder='Mật khẩu'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              secureTextEntry
              returnKeyType='done'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('password', text)}
              onSubmitEditing={this._doLogin}/>
          </View>

          <TouchableOpacity
            activeOpacity={0.75}
            style={styles.submit}
            onPress={this._login}>
            <Image
              source={require('../img/btn.png')}
              style={styles.submitImage}/>
            <Text
              style={styles.submitText}>
              ĐĂNG NHẬP
            </Text>
            {submitting && <View
              style={styles.submitting}>
              <ActivityIndicator
                animating={true}
                color='#ffffff'
                style={styles.submittingIndicator}/>
            </View>}
          </TouchableOpacity>

          <TouchableOpacity
            activeOpacity={0.75}
            style={[
              styles.submit, {
                marginTop: 12,
              }]}
            onPress={this._register}>
            <Image
              source={require('../img/btn.png')}
              style={styles.submitImage}/>
            <Text
              style={styles.submitText}>
              ĐĂNG KÍ
            </Text>
          </TouchableOpacity>
        </KeyboardAwareScrollView>

        {/*<View
          style = { styles.passwordDivider } />
        <TouchableOpacity
          activeOpacity = { 0.75 }
          style = { styles.password }
          onPress = { this._forgetPassword }>
          <Text
            style = { styles.passwordText }>
            Quên mật khẩu?
          </Text>
        </TouchableOpacity>*/}

        {Platform.OS !== 'web' && <TouchableOpacity
          activeOpacity={0.75}
          style={styles.close}
          onPress={this._close}>
          <FontAwesomeIcon
            name='times-circle'
            size={36}
            color='#fd5c5c'
            style={styles.closeIcon}/>
        </TouchableOpacity>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {},

  logo: {
    height: logoHeight,
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    overflow: 'hidden',
  },
  logoBackground: {
    position: 'absolute',
    top: 0, left: 0, right: 0,
    height: logoHeight,
    resizeMode: 'cover',
  },
  logoImage: {
    width: logoImageSize,
    height: logoImageSize,
    resizeMode: 'contain',
  },

  input: {
    width: formWidth,
    height: 44,
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: 20,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  submit: {
    width: formWidth,
    height: 56,
    marginTop: 24,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  submitImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: formWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  submitText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  submitting: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  submittingIndicator: {},

  passwordDivider: {
    marginLeft: 12,
    marginRight: 12,
    height: 1 / PixelRatio.get(),
    backgroundColor: '#d7cba9',
  },
  password: {
    height: 56,
    justifyContent: 'center',
    alignItems: 'center',
  },
  passwordText: {
    color: '#128500',
    fontSize: 20,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },

  close: {
    position: 'absolute',
    top: 20, right: 20,
    width: 44,
    height: 44,
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeIcon: {
    backgroundColor: 'transparent',
  },
});

const mapStateToProps = (state) => {
  return {
    credential: state.user.credential,
    device: state.device,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCredential: (credential) => dispatch(updateCredential(credential)),
    updateInfo: (info) => dispatch(updateInfo(info)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);



// WEBPACK FOOTER //
// ./src/auth/LoginScreen.js